module.exports = __webpack_public_path__ + "img/buy.d06d22b5.svg";